import React, {useState, useEffect} from 'react';
import '../styles/EditProjectReportModal.css';

export default function CustomReportModal({users, dateRange, onClose, onSubmit}) {

    const [allEntries, setAllEntries] = useState({});

    // Initialize entries per user when modal opens
    useEffect(() => {
        const initialEntries = {};
        users.forEach(user => {
            initialEntries[user.userId] = user.entries.map(e => ({
                ...e,
                location: e.location || 'OnSite'
            }));
        });
        setAllEntries(initialEntries);
    }, [users]);

    const handleEntryChange = (userId, index, field, value) => {
        const updatedEntries = [...allEntries[userId]];


        if (field === 'date') {
            const dateValue = new Date(value);
            const start = new Date(dateRange.startDate);
            const end = new Date(dateRange.endDate);

            if (dateValue < start || dateValue > end) {
                alert(`Datum außerhalb des erlaubten Bereichs: ${dateRange.startDate} bis ${dateRange.endDate}`);
                return;
            }
        }

        updatedEntries[index] = {...updatedEntries[index], [field]: value};

        updatedEntries.sort((a, b) => new Date(a.date) - new Date(b.date));

        setAllEntries(prev => ({
            ...prev,
            [userId]: updatedEntries
        }));
    };

    const handleAddEntry = (userId) => {
        const newEntry = {
            date: new Date().toISOString().split('T')[0],
            startTime: '08:00',
            endTime: '17:00',
            breakMinutes: 30,
            travelMinutes: 0,
            activity: '',
            comment: '',
            location: 'OnSite',
            userId: userId
        };

        const updated = [...(allEntries[userId] || []), newEntry];

        updated.sort((a, b) => new Date(a.date) - new Date(b.date));

        setAllEntries(prev => ({
            ...prev,
            [userId]: updated
        }));
    };

    const handleSubmit = () => {
        const result = [];

        Object.entries(allEntries).forEach(([userId, entries]) => {
            if (entries.length > 0) {
                result.push({
                    userId,
                    entries
                });
            }
        });

        if (result.length === 0) {
            alert("Keine Einträge zum Speichern.");
            return;
        }

        onSubmit(result);
        onClose();
    };

    return (
        <div className="modal-report-overlay">
            <div className="modal-report">
                <h3>Einträge bearbeiten</h3>

                {users.map(user => (
                    <div key={user.userId} style={{marginBottom: '30px'}}>
                        <h4>{user.username}</h4>

                        <button onClick={() => handleAddEntry(user.userId)} className="button"
                                style={{marginBottom: '10px'}}>
                            + Neuer Eintrag für {user.username}
                        </button>

                        <table className="table">
                            <thead>
                            <tr>
                                <th>Datum</th>
                                <th>Start</th>
                                <th>Ende</th>
                                <th>Pause</th>
                                <th>Fahrtzeit</th>
                                <th>Einsatzort</th>
                                <th>Aktivität</th>
                                <th>Kommentar</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(allEntries[user.userId] || []).map((entry, index) => (
                                <tr key={index}>
                                    <td>
                                        <input type="date"
                                               value={entry.date}
                                               onChange={e => handleEntryChange(user.userId, index, 'date', e.target.value)}/>
                                    </td>
                                    <td>
                                        <input type="time"
                                               value={entry.startTime}
                                               onChange={e => handleEntryChange(user.userId, index, 'startTime', e.target.value)}/>
                                    </td>
                                    <td>
                                        <input type="time"
                                               value={entry.endTime}
                                               onChange={e => handleEntryChange(user.userId, index, 'endTime', e.target.value)}/>
                                    </td>
                                    <td>
                                        <input type="number"
                                               value={entry.breakMinutes}
                                               onChange={e => handleEntryChange(user.userId, index, 'breakMinutes', e.target.value)}
                                               style={{width: '60px'}}/>
                                    </td>
                                    <td>
                                        <input type="number"
                                               value={entry.travelMinutes}
                                               onChange={e => handleEntryChange(user.userId, index, 'travelMinutes', e.target.value)}
                                               style={{width: '60px'}}/>
                                    </td>
                                    <td>
                                        <select
                                            value={entry.location || 'OnSite'}
                                            onChange={e =>
                                                handleEntryChange(user.userId, index, 'location', e.target.value)
                                            }
                                            className="input"
                                        >
                                            <option value="OnSite">OnSite</option>
                                            <option value="Remote">Remote</option>
                                            <option value="Office">Office</option>
                                            <option value="HomeOffice">HomeOffice</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text"
                                               value={entry.activity}
                                               onChange={e => handleEntryChange(user.userId, index, 'activity', e.target.value)}/>
                                    </td>
                                    <td>
                                        <input type="text"
                                               value={entry.comment}
                                               onChange={e => handleEntryChange(user.userId, index, 'comment', e.target.value)}/>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ))}

                <div style={{marginTop: '20px'}}>
                    <button onClick={handleSubmit} className="button">Bericht generieren</button>
                    <button onClick={onClose} className="button button-danger" style={{marginLeft: '10px'}}>Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
}
